import type { FeaturedPortalSummary, UnFeaturedPortalSummary } from 'rest/featured-and-sorted-portals';
import { isFeaturedPortal, isHiddenPortal } from 'state/selectors/featured-and-sorted-portals';
import type { PortalSummaries } from 'state/persisted/featured-and-sorted-portals/reducer';
import { nanToZero } from 'state/ui/featured-and-sorted-portals';

export const getFeaturedPortals = (portals: PortalSummaries): FeaturedPortalSummary[] => {
    return (
        Object.values(portals)
            .filter((portal) => isFeaturedPortal(portal))
            // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            .sort((portal1, portal2) => nanToZero(portal1.rank) - nanToZero(portal2.rank))
    );
};

export const getHiddenPortals = (portals: PortalSummaries): (FeaturedPortalSummary | UnFeaturedPortalSummary)[] => {
    return Object.values(portals).filter((portal) => isHiddenPortal(portal));
};

/**
 * We have cleaned up the feature flag used for Portal reordering changeboarding,
 *  but keeping the logic as it is so that we can enable the FF whenever there is a need
 * e.g: When new admin FF is rolled out through customization drawer
 */
export const isPortalReorderingChangeboardingEnabled = () => {
    return false;
};
